export default "__VITE_ASSET__cbde9329__"